import { Link } from 'react-router-dom';
import './ArticleCard.css';

// Helper function to strip HTML tags and decode HTML entities
const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

function ArticleCard({ id, title, excerpt, date, imageUrl }) {
  const [day, month, year] = date.split('/').map(Number);
  const dateObj = new Date(year, month - 1, day);

  const hasImage = imageUrl && imageUrl.trim() !== '';

  return (
    <Link to={`/articles/${id}`} className="article-card-link">
      <article className="article-card">
        <div className="article-card-content">
          <div className="article-card-date">
            {dateObj.toLocaleDateString('it-IT', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
          </div>
          {hasImage ? (
            <div className="article-card-image">
              <img src={imageUrl} alt={title} />
            </div>
          ) : (
            <div className="article-card-image article-card-placeholder">
              <i className="fa-regular fa-newspaper" style={{ fontSize: '3rem', color: 'white', opacity: 0.5 }}></i>
            </div>
          )}
          <h3>{title}</h3>
          {excerpt && <p>{stripHtml(excerpt)}</p>}
          <div className="read-more">
            Leggi di più →
          </div>
        </div>
      </article>
    </Link>
  );
}

export default ArticleCard;
